import * as MobileDetect from 'mobile-detect';

export class MobileUtils {
  static readonly isMobile: boolean = new MobileDetect(window.navigator.userAgent).mobile() != null;
}
